import React, { useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";

const OutlineIcon = (props) => {
  const { theme } = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 32 32"
      fill="none"
    >
      <circle
        cx="16.0003"
        cy="15.9974"
        r="12.5833"
        stroke={props.active ? "#0085FF" : theme.palette.inactiveTool}
        strokeWidth="2"
        strokeDasharray="6 3"
      />
    </svg>
  );
};

export default OutlineIcon;
